module.exports = __webpack_public_path__ + "img/login-bg.4852a278.png";